import React from 'react';
import moment from 'moment';
import SharedTimepicker from '../SharedTimepicker';
import {dbDateFormat, isMobile} from '../../../services/Helpers';

const DateQuestion = ({question, value, onChange, error, disabled}) => {
    const answerDate = value ? moment(value, dbDateFormat) : undefined;
    const isTodayOnly = question.settings?.range !== 'any';

    return <SharedTimepicker type={'date'} value={answerDate} min={isTodayOnly ? answerDate : undefined} max={isTodayOnly ? answerDate : undefined} onChange={(date) => onChange(moment(date).format(dbDateFormat))} isDisabled={disabled} isError={!!error} inputStyle={[{width: isMobile ? '100%' : '10rem'}]}/>;
};

export default DateQuestion;
